import React from 'react';

export const NewsArticleContent = (props) => {
  return <div className="__news-article-content" {...props} />;
};
